<template>

</template>

<script>
export default {
  data() {
    return {
      params: {},
      token: this.$route.query.token,
      method: this.$route.query.method
    };
  },
  created() {
    if (!this.method) {
       this.$router.push('/')
    }
    this.setParams();
    if (this.token) {
      this.checkToken();
    } else {
      this.redirect();
    }
  },
  methods: {
    async checkToken() {
      var params = {
        token: this.token,
        isAuth: 1
      };
      await this.$post("/user/checkToken", params).then(response => {
        if (response.code === 0) {
          this.$storage.saveUserName(response.data);
          sensors.login(response.data)
        }
      });
      this.redirect();
    },
    redirect(){
      if (!this.method) {
        return;
      }
      if (this.method.indexOf('.')) {
        this.method = '/' + this.method.replace(/\./g, '/');
      }
      this.$router.push({path: this.method, query: this.params})
    },
    setParams(){
      var query = location.search.substring(1);
      if (!query) {
        return;
      }
      var arr = query.split('&');
      if (arr != null && arr.length <= 0) {
        return;
      }
      for (var i = 0; i < arr.length; i++) {
        var pair = arr[i].split('=');
        if (pair[0] !== 'token' && pair[0] !== 'method') {
          this.params[pair[0]] = pair[1];
        }
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/common/Gateway.vue